import { createContext, useContext } from "react";

const ArtFieldMetadataContext = createContext(null);

export const ArtFieldMetadataProvider = ({ fields, children }) => {
    return (
        <ArtFieldMetadataContext.Provider value={fields || null}>
            {children}
        </ArtFieldMetadataContext.Provider>
    );
};

export const useArtFieldMetadata = (fieldName) => {
    const fields = useContext(ArtFieldMetadataContext);

    if (!fields || !fieldName) {
        return null;
    }

    return fields[fieldName] || null;
};
